
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2(308|516|887)|1(169|850|976)|8(124|544|821|867)|7(7(28|52|77)|291|325)|3(372|552|724)|9(252|330|397|56)|(592|607|641)8|4434|4905)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
